// extracted by mini-css-extract-plugin
export var carrierIcon = "_wh-0";
export var carrierLogo = "_wh-1";
export var detailsSection = "_wh-2";